<template>
  <div class="">
    <div class="flex items-center mb-2 space-x-4">
      <!-- Select Component -->
      <div class="flex flex-col space-x-2 items-left -mt-7">
        <label
          for="mobileSelect"
          class="ml-2 text-sm font-medium text-gray-700 "
          >Select Mobile to WhatsApp invoice
        </label>
        <select
          id="mobileSelect"
          v-model="selectedMobile"
          class="px-4 py-2 bg-white border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option
            v-for="(item, index) in userMobiles"
            :value="item.value"
            :label="item.label + ' : ' + item.value"
            :key="index"
            >{{ item }}</option
          >
          <option value="">Enter Manually</option>
        </select>
      </div>

      <!-- Input Field -->
      <div class="flex flex-col space-x-2 items-left -mt-7">
        <label
          for="mobileSelect"
          class="ml-2 text-sm font-medium text-gray-700 "
          >Enter number manually
        </label>
        <input
          v-model="selectedMobile"
          type="text"
          placeholder="Or enter phone here"
          class="px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>

      <!-- Button -->
      <button
        @click="handleSendWhatsappChalanInvoice()"
        class="px-6 py-2 text-white bg-blue-500 rounded hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        <div class="flex">
          <span>
            Send to Whatsapp
          </span>
          <span v-if="isWhatsappLoader" class="ml-2 no-rows">
            <i class="fas fa-spinner fa-spin" />
          </span>
        </div>
      </button>

      <button
        @click="handlePrint()"
        class="px-6 py-2 text-white bg-gray-600 rounded hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500"
      >
        <div class="flex">
          <i class="mr-2 fas fa-print" />
          <span>Print</span>
        </div>
      </button>
    </div>
    <div class="p-3 bg-gray-100">
      <div
        ref="printArea"
        class="max-w-4xl p-4 mx-auto bg-white rounded-lg shadow-md"
      >
        <div class="flex items-center justify-between pb-4 mb-4 border-b">
          <div>
            <h1 class="text-2xl font-bold text-gray-700">Chalan</h1>
            <p class="text-sm text-gray-500">
              {{ data.chalanNumber }}
            </p>
            <p class="text-sm text-gray-500">
              Date: {{ data.updatedAt | convertDate }}
            </p>
          </div>
          <div class="text-right">
            <p class="text-lg font-bold text-gray-800">{{ branchDisplayName }}</p>
            <p v-if="branchAddressLines[0]" class="text-sm text-gray-500">{{ branchAddressLines[0] }}</p>
            <p v-if="branchAddressLines[1]" class="text-sm text-gray-500">{{ branchAddressLines[1] }}</p>
            <p v-if="branchPhone" class="text-sm text-gray-500">Phone: {{ branchPhone }}</p>
            <p v-if="branchGstin" class="text-sm text-gray-500">GSTIN: {{ branchGstin }}</p>
          </div>
        </div>

        <!-- Recipient Details -->
        <div class="mb-4">
          <h3 class="mb-2 text-lg font-semibold text-gray-700">Bill To:</h3>
          <p class="text-sm text-gray-500">
            {{ data.users.firstName + " " + data.users.lastName }}
          </p>
          <!-- <p class="text-sm text-gray-500">{{ client.address }}</p> -->
          <p class="text-sm text-gray-500">Phone: {{ data.users.phone }}</p>
        </div>

        <!-- Items Table -->
        <div class="mb-6">
          <table class="w-full text-sm border border-collapse border-gray-200">
            <thead>
              <tr class="bg-gray-100">
                <th class="px-4 py-2 text-left border border-gray-200">
                  Product
                </th>
                <th class="px-4 py-2 text-right border border-gray-200">
                  Price
                </th>
                <th class="px-4 py-2 text-right border border-gray-200">
                  Qty
                </th>
                <th class="px-4 py-2 text-right border border-gray-200">
                  Tax %
                </th>
                <th class="px-4 py-2 text-right border border-gray-200">
                  Total
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in data.chalanItems" :key="index">
                <td class="px-4 py-2 border border-gray-200">
                  {{ item.name }}
                </td>
                <td class="px-4 py-2 text-right border border-gray-200">
                  {{ item.price | currency }}
                </td>
                <td class="px-4 py-2 text-right border border-gray-200">
                  {{ item.quantity }}
                </td>
                <td class="px-4 py-2 text-right border border-gray-200">
                  {{ item.taxRate }}
                </td>
                <td class="px-4 py-2 text-right border border-gray-200">
                  {{ item.amount | currency }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Footer -->
        <div class="flex items-center justify-between pt-4 border-t">
          <div>
            <h3 class="text-lg font-semibold text-gray-700">Notes</h3>
            <p class="text-sm text-gray-500">Thank you visit again!</p>
          </div>
          <div class="text-right">
            <p class="text-sm text-gray-500">
              Total:
              <span class="font-semibold">{{ data.total | currency }}</span>
            </p>
            <p class="text-sm text-gray-500">
              Total Tax: <span class="font-semibold">{{ tax | currency }}</span>
            </p>
            <p class="text-lg font-bold text-gray-700">
              Rounded Total: {{ data.grandTotal | currency }}
            </p>
          </div>
        </div>
        <div class="flex justify-center pt-4 mt-2 border-t">
          <img
            src="../../assets/images/rajput.png"
            width="260"
            height="40"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";
import { apiHelper } from "../../utils/helpers";
import endpoints from "@/utils/constants";
import { printElementAsA4 } from "@/utils/printA4";
import branchDetailsMixin from "@/mixins/branchDetailsMixin";

export default {
  name: "ChalanDesign",
  mixins: [branchDetailsMixin],
  props: {
    data: {
      required: true,
      type: Object
    }
  },
  data: () => {
    return {
      isWhatsappLoader: false,
      userMobiles: [],
      selectedMobile: null
    };
  },
  filters: {
    currency(value) {
      const amount = parseFloat(value) || 0;
      const a = new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR"
      }).format(amount);
      return a.replace(".00", "");
    },
    convertDate(date) {
      return format(date, "YYYY-MM-DD");
    }
  },

  mounted() {
    this.getUserMobiles();
    this.loadBranchDetails(this.$store.state.user.branchId);
  },
  methods: {
    resetProperty() {
      this.userMobiles = null; // Reset the property
      this.selectedMobile = null;
    },
    handlePrint() {
      printElementAsA4(this.$refs.printArea, { title: "Chalan" });
    },
    getUserMobiles() {
      const userId =
        this.data && this.data.users && this.data.users.userId
          ? this.data.users.userId
          : null;
      if (!userId) {
        this.userMobiles = [];
        return;
      }
      apiHelper
        .call(
          "get",
          `${endpoints.LARAVEL_BASE_URL}/api/v1/users/${userId}/mobiles`
        )
        .then(response => {
          this.userMobiles = response.data.mobiles;
        })
        .catch(err => {
          this.$notify({
            message: "Something went wrong",
            type: "danger",
            title: "Error"
          });
        });
    },

    handleSendWhatsappChalanInvoice() {
      const serviceRequestChalanId = this.data.serviceRequestChalanId;
      const customerChalanId = this.data.customerChalanId;
      const sendUrl = serviceRequestChalanId
        ? `${endpoints.LARAVEL_BASE_URL}/api/v1/send/chalan-invoice/${serviceRequestChalanId}`
        : customerChalanId
        ? `${endpoints.LARAVEL_BASE_URL}/api/v1/send/customer-chalan-invoice/${customerChalanId}`
        : null;

      if (!sendUrl) {
        this.$notify({
          message: "Cannot send this chalan on WhatsApp",
          type: "warning",
          title: "Warning"
        });
        return;
      }

      this.isWhatsappLoader = true;
      apiHelper
        .call("post", sendUrl, { phone: this.selectedMobile })
        .then(response => {
          this.isWhatsappLoader = false;
          this.userMobiles = [];
          this.selectedMobile = null;
          this.$notify({
            message: "Invoice sent to whtasapp",
            type: "success",
            title: "Success"
          });
        })
        .catch(err => {
          this.isWhatsappLoader = false;
          this.$notify({
            message: "Something went wrong",
            type: "danger",
            title: "Error"
          });
        });
    }
  },
  computed: {
    subtotal() {
      return this.items.reduce((sum, item) => sum + item.total, 0);
    },
    tax() {
      const items =
        (this.data && this.data.chalanItems) || [];
      return items.reduce((a, b) => a + (parseFloat(b.taxAmount) || 0), 0);
    },
    total() {
      return this.subtotal + this.tax;
    }
  }
};
</script>

<style scoped>
/* Add any additional custom styling here if needed */
</style>
